import type { Website } from "@/constants/features";
import * as api from "../client";

export type FirmLogoSource = "wordpress" | "profile" | "portal" | "staff";

export type FirmLogo = {
  id: string;
  companyId: string;
  website: Website;
  countryId: number | null;
  logoHash: string;
  logoFilename: string;
  source: FirmLogoSource;
  updatedBy: string | null;
  createdAt: string;
  updatedAt: string;
  editable: boolean;
};

export type SetFirmLogoInput = {
  companyId: string;
  website: Website;
  countryId: number | null;
  logoHash: string;
  logoFilename: string;
};

const BASE = "/v1/profiles/firm-logos";

export const firmLogosService = {
  async list(companyId: string): Promise<FirmLogo[]> {
    const raw = await api.get<{ firmLogos: FirmLogo[] }>(
      `${BASE}?companyId=${encodeURIComponent(companyId)}`,
    );

    return raw.firmLogos;
  },

  async set(input: SetFirmLogoInput): Promise<FirmLogo> {
    const raw = await api.put<{ firmLogo: FirmLogo }>(BASE, input);

    return raw.firmLogo;
  },

  remove(id: string): Promise<void> {
    return api.del<void>(`${BASE}/${encodeURIComponent(id)}`);
  },
};
